import React, { useEffect, useState, useRef } from "react";
import Select, { components } from "react-select";
import cn from "classnames";
import style from "./index.module.scss";
import "./select-custom.scss";
import { t } from "i18next";

const selectStyles = {
  menu: (provided) => ({
    ...provided,
    paddingBottom: 0,
  }),
  menuList: (provided) => ({
    ...provided,
    paddingBottom: 0,
    maxHeight: "300px",
  }),
};

const portalStyles = {
  ...selectStyles,
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
};

const CLASS_NAMES = {
  name: "select-custom-wrapper",
  root: "custom-select",
};

const CustomSelectMulti = ({
  placeholder = "Выберите вариант",
  keyId = "id",
  keyName = "name",
  isDisabled = false,
  options = [],
  onSubmit,
  bgGray = false,
  isMulti = false,
  defaultValue = [],
  labelText = "",
  errorText = "",
  protectDefaultValues = false,
  usePortal = false,
  forceMenuTop = false,
}) => {
  const isProtectedValuesInitialized = useRef(false);
  const [selectedOptions, setSelectedOptions] = useState(defaultValue);
  const [protectedValues, setProtectedValues] = useState([]);

  const onOptionChangeHandler = (selected) => {
    if (selected.some((opt) => opt[keyId] === "selectAll")) {
      if (selectedOptions.length === options.length) {
        if (protectDefaultValues && protectedValues.length > 0) {
          setSelectedOptions(protectedValues);
          onSubmit(protectedValues);
        } else {
          setSelectedOptions([]);
          onSubmit([]);
        }
      } else {
        setSelectedOptions(options);
        onSubmit(options);
      }
    } else {
      if (protectDefaultValues) {
        const protectedIds = protectedValues.map(item => item[keyId]);
        const hasAllProtectedItems = protectedIds.every(id => 
          selected.some(item => item[keyId] === id)
        );
        
        if (hasAllProtectedItems) {
          setSelectedOptions(selected);
          onSubmit(selected);
        } else {
          const missingProtectedItems = protectedValues.filter(defaultItem =>
            !selected.some(selectedItem => selectedItem[keyId] === defaultItem[keyId])
          );
          const restoredSelection = [...selected, ...missingProtectedItems];
          setSelectedOptions(restoredSelection);
          onSubmit(restoredSelection);
        }
      } else {
        setSelectedOptions(selected);
        onSubmit(selected);
      }
    }
  };

  const enhancedOptions = [
    { [keyId]: "selectAll", [keyName]: t("ordersCreateDesktop.paymentSection.chooseAll") },
    ...options,
  ];

  const isOptionSelected = (option) =>
    selectedOptions.some((selected) => selected[keyId] === option[keyId]);

  const CustomMultiValueRemove = (props) => {
    const optionValue = props.data[keyId];
    const isProtected = protectedValues.some(item => item[keyId] === optionValue);

    if (protectDefaultValues && isProtected) {
      return null;
    }

    return <components.MultiValueRemove {...props} />;
  };

  const CustomMultiValueLabel = (props) => (
    <components.MultiValueLabel {...props}>
      <span className={style.multiValueLabel} title={props.data[keyName]}>
        {props.data[keyName]}
      </span>
    </components.MultiValueLabel>
  );

  useEffect(() => {
    if (protectDefaultValues && !isProtectedValuesInitialized.current && defaultValue.length > 0) {
      setProtectedValues(defaultValue);
      isProtectedValuesInitialized.current = true;
      setSelectedOptions(defaultValue);
    }
  }, [defaultValue, protectDefaultValues]);

  return (
    <div
      className={cn(CLASS_NAMES.root, style.select_control, {
        [CLASS_NAMES.root + "__bgGray"]: bgGray,
      })}
    >
      <label
        className={cn(style.labelInp, {
          [style.focusedLabel]: selectedOptions.length > 0,
          [style.labelError]: errorText,
        })}
      >
        {labelText}
      </label>
      <Select
        value={selectedOptions}
        onChange={onOptionChangeHandler}
        placeholder={placeholder}
        className={cn(CLASS_NAMES.name, {
          [style.input_errorState]: errorText,
          [CLASS_NAMES.name + "__isMulti"]: isMulti,
        })}
        classNamePrefix={CLASS_NAMES.name + "__content"}
        getOptionLabel={(option) => (
          <div className={style.optionLabel}>
            <input
              type="checkbox"
              checked={isOptionSelected(option)}
              onChange={() => {}}
              className={style.checkbox}
            />
            <span>{option[keyName]}</span>
          </div>
        )}
        getOptionValue={(option) => option[keyId]}
        options={enhancedOptions}
        isMulti={isMulti}
        isDisabled={isDisabled}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        components={{
          MultiValueRemove: CustomMultiValueRemove,
          MultiValueLabel: CustomMultiValueLabel,
        }}
        styles={usePortal ? portalStyles : selectStyles}
        menuPlacement={forceMenuTop ? "top" : "auto"}
        {...(usePortal && {
          menuPortalTarget: document.body,
          menuPosition: "fixed",
        })}
      />
      {errorText && <div className={style.errorText}>{errorText}</div>}
    </div>
  );
};

export default CustomSelectMulti;
